'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  Copyright 2019 Adobe Inc. All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  This file is licensed to you under the Apache License, Version 2.0 (the "License");
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  you may not use this file except in compliance with the License. You may obtain a copy
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  of the License at http://www.apache.org/licenses/LICENSE-2.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  Unless required by applicable law or agreed to in writing, software distributed under
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  OF ANY KIND, either express or implied. See the License for the specific language
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  governing permissions and limitations under the License.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _WAMConstants = require('./constants/WAMConstants');

var _WAMConnectionManager = require('./WAMConnectionManager');

var _WAMConnectionManager2 = _interopRequireDefault(_WAMConnectionManager);

var _WAMUtil = require('./WAMUtil');

var _WAMUtil2 = _interopRequireDefault(_WAMUtil);

var _uuid = require('uuid');

var _uuid2 = _interopRequireDefault(_uuid);

var _GlobalData = require('./util/GlobalData');

var _GlobalData2 = _interopRequireDefault(_GlobalData);

var _AnalyticsUtil = require('./util/AnalyticsUtil');

var _AnalyticsUtil2 = _interopRequireDefault(_AnalyticsUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WAMMessageManager = function () {

	// Singleton
	function WAMMessageManager() {
		_classCallCheck(this, WAMMessageManager);

		if (this.instance) {
			return this.instance;
		}
		this.instance = this;
		this.analyticsRepo = {};
		this.products = null;
		this.appsPanelHidden = null;
		this.thorAppsPanelStatus = _WAMConstants.wamMsgStatusType.thorAppsState.cchDefault;
	}

	/*
  *	To send message to other client in this case to Thor
  *
  */


	_createClass(WAMMessageManager, [{
		key: 'sendMsg',
		value: function sendMsg(msgType, payload) {
			if (!_WAMConnectionManager2.default.socket) {
				return;
			}
			_WAMConnectionManager2.default.socket.emit(msgType, payload);
		}
	}, {
		key: 'clearAnalyticsRepo',
		value: function clearAnalyticsRepo(sapcode, version) {
			var key = sapcode + '_' + version;
			delete this.analyticsRepo[key];
		}
	}, {
		key: 'resetThorAppsState',
		value: function resetThorAppsState() {
			this.thorAppsPanelStatus = _WAMConstants.wamMsgStatusType.thorAppsState.cchDefault;
		}
	}, {
		key: 'resetThorAppList',
		value: function resetThorAppList() {
			this.products = null;
		}

		/*
   *	To provide clientMsg to appropriate Msghandle which has registered itself.
   *  In this case the message is forwared to AppsMain which will propagate it to respective action/reducer.
   */

	}, {
		key: 'setCallbackForClientMsg',
		value: function setCallbackForClientMsg() {
			var _this = this;

			if (!_WAMConnectionManager2.default.socket) {
				return;
			}
			if (_WAMConnectionManager2.default.socket.hasListeners(_WAMConstants.wamEvents.receiveEvents.clientMsg)) {
				return;
			}
			_WAMConnectionManager2.default.socket.on(_WAMConstants.wamEvents.receiveEvents.clientMsg, function (statusMessages) {
				if (statusMessages && statusMessages.messages) {
					statusMessages.messages.forEach(function (statusMessage) {
						if (!_this.processMsg(statusMessage)) {
							return;
						}
						if (_this.thorAppsPanelStatus === _WAMConstants.wamMsgStatusType.thorAppsState.loaded && _this.onProductsStateReceived) {
							_this.onProductsStateReceived();
						}
						_WAMUtil2.default.clientMsgHandlers && _WAMUtil2.default.clientMsgHandlers.forEach(function (clientMsgHandler) {
							clientMsgHandler(_this.products);
						});
					});
				}
			});
		}

		// parse the message coming from Thor to extract apps state and latest status of the command being executed.

	}, {
		key: 'processMsg',
		value: function processMsg(statusMessage) {
			_WAMUtil2.default.printLog(statusMessage);
			if (this.products) {
				// resetting the previously set updateAllConfirmation
				this.products[_WAMConstants.thorAppsStatesCategory.updateAllConfirmation] = [];
			}
			if (statusMessage.msgBody) {
				var statusData = statusMessage.msgBody.status;
				switch (statusData.status) {
					case _WAMConstants.wamMsgStatusType.appsPanelInstallAvailabilityStatus:
						this.appsPanelHidden = statusData.appsPanelHidden;
						return false;
					case _WAMConstants.wamMsgStatusType.thorAppsState.loading:
					case _WAMConstants.wamMsgStatusType.thorAppsState.appRefreshedStarted:
						{
							this.thorAppsPanelStatus = statusData.status;
							return false;
						}
					case _WAMConstants.wamMsgStatusType.thorAppsState.loadingFailed:
					case _WAMConstants.wamMsgStatusType.thorAppsState.loaded:
						{
							this.getAppsFromThor(statusData);
							return true;
						}
					case _WAMConstants.wamMsgStatusType.closeConfirmation:
						{
							if (statusData.confirmationDetails && statusData.confirmationDetails.confirmationID) {
								var _product = this.getProduct(this.products, null, null, statusData.confirmationDetails.confirmationID);
								if (_product) {
									_product.status = null;
								}
								_GlobalData2.default.callbacks.onCloseConfirmationCallbacks && _GlobalData2.default.callbacks.onCloseConfirmationCallbacks.forEach(function (closeCallback) {
									closeCallback(statusData.confirmationDetails.confirmationID);
								});
							}
							return false;
						}
				}
				var sapCode = statusMessage.msgBody.sapCode;
				var version = statusMessage.msgBody.version;
				var product = this.getProduct(this.products, sapCode, version);
				if (product) {
					product.showRetryBtn = false;
					product.action = statusData.command;
					product.status = statusData.status;
					this.sendAnalytics(product);
					switch (statusData.status) {
						case _WAMConstants.wamMsgStatusType.waiting:
							product.cancelable = statusData.cancelable;
							break;
						case _WAMConstants.wamMsgStatusType.inprogress:
							product.totalProgressPercent = statusData.totalProgressPercent;
							if (!product.totalProgressPercent) {
								// Bug fix: CCH-7806
								product.totalProgressPercent = statusData.total_progress_percent;
							}
							product.cancelable = statusData.cancelable;
							break;
						case _WAMConstants.wamMsgStatusType.needConfirmation:
							if (!statusData.confirmationDetails) {
								return false;
							}
							product.confirmationDetails = statusData.confirmationDetails;
							break;
						case _WAMConstants.wamMsgStatusType.failed:
							if (statusData.errorDetails && statusData.errorDetails.errorCode) {
								product.showRetryBtn = true;
								product.error_details = statusData.errorDetails;
								/* eslint camelcase: ["error", {properties: "never"}] */
								product.error_details.error_code = statusData.errorDetails.errorCode;
							}
							break;
						case _WAMConstants.wamMsgStatusType.completed:
							// updating the startTrial status
							if (product.stateCategory === _WAMConstants.thorAppsStatesCategory.installed && statusData.command === _WAMConstants.ccHomeCommands.ccHomeToThorCommands.startTrial) {
								if (statusData.trialDetails.isProductInTrial === 'True') {
									product.entitlement_info = {
										status: _WAMConstants.trialTypes.trialActive,
										trialDaysRemaining: statusData.trialDetails.trialDaysRemaining
									};
									product.launchable = 'true';
								} else if (statusData.trialDetails.isTrialExpired === 'True') {
									product.entitlement_info = {
										status: _WAMConstants.trialTypes.trialExpired
									};
								}
							}
							break;
					}
				} else {
					/**
      * To handle app unknown scenario
      */
					if (sapCode && version && statusData.status && statusData.status === _WAMConstants.wamMsgStatusType.appUnknown) {
						_AnalyticsUtil2.default.sendAnalytics({
							eventName: _WAMConstants.analyticsEvents.onAppUnknown,
							sapcode: sapCode, version: version,
							commandName: 'install', commandStage: 'app-unknown'
						});
						this.addToAppUnkown(sapCode, version, statusData.status);
					}
					/**
      * UpdateAll workflow is not product specific hence it doesn't have sapcode and version data in it
      * This requires special handling.
      * @type {*[]}
      */
					else if (statusData.status === _WAMConstants.wamMsgStatusType.needConfirmation) {
							if (!statusData.confirmationDetails) {
								return false;
							}
							// setting the data for  updateAllConfirmation box

							this.products[_WAMConstants.thorAppsStatesCategory.updateAllConfirmation] = [{
								sapcode: _WAMConstants.thorAppsStatesCategory.updateAllConfirmation,
								version: _WAMConstants.thorAppsStatesCategory.updateAllConfirmation,
								status: statusData.status,
								stateCategory: _WAMConstants.thorAppsStatesCategory.updateAllConfirmation,
								confirmationDetails: statusData.confirmationDetails
							}];
						}
				}
				return true;
			}
		}
	}, {
		key: 'sendAnalytics',
		value: function sendAnalytics(productFromThor) {
			var _this2 = this;

			var key = productFromThor.sapcode + '_' + productFromThor.version;
			var start = 'start';
			var end = 'end';
			var sendProgressAnalytics = function sendProgressAnalytics(commandStage) {
				var eventValue = void 0;
				switch (commandStage) {
					case start:
					case end:
						eventValue = _this2.analyticsRepo[key];
						break;
					case _WAMConstants.wamMsgStatusType.cancelling.toLowerCase():
						eventValue = productFromThor.totalProgressPercent || _WAMConstants.wamMsgStatusType.waiting;
						break;
				}
				_AnalyticsUtil2.default.sendAnalytics({
					eventName: _WAMConstants.analyticsEvents.onCommandProgress,
					sapcode: productFromThor.sapcode, version: productFromThor.version,
					commandName: productFromThor.action, commandStage: commandStage, eventValue: eventValue
				});
			};
			if (productFromThor) {
				if (productFromThor.totalProgressPercent && productFromThor.status && productFromThor.status === _WAMConstants.wamMsgStatusType.inprogress) {
					var percentProgress = parseInt(productFromThor.totalProgressPercent);
					if (percentProgress >= 0 && percentProgress <= 20) {
						if (this.analyticsRepo[key] === '0') {
							return;
						}
						this.analyticsRepo[key] = '0';
						sendProgressAnalytics(start);
					} else if (percentProgress >= 25 && percentProgress <= 40) {
						if (this.analyticsRepo[key] === '25') {
							return;
						}
						this.analyticsRepo[key] = '25';
						sendProgressAnalytics(start);
					} else if (percentProgress >= 50 && percentProgress <= 65) {
						if (this.analyticsRepo[key] === '50') {
							return;
						}
						this.analyticsRepo[key] = '50';
						sendProgressAnalytics(start);
					} else if (percentProgress >= 75 && percentProgress <= 90) {
						if (this.analyticsRepo[key] === '75') {
							return;
						}
						this.analyticsRepo[key] = '75';
						sendProgressAnalytics(start);
					}
				}
				if (productFromThor.status && productFromThor.status === _WAMConstants.wamMsgStatusType.completed) {
					if (this.analyticsRepo[key] === '100') {
						return;
					}
					this.analyticsRepo[key] = '100';
					sendProgressAnalytics(end);
				}
				if (productFromThor.status && productFromThor.status === _WAMConstants.wamMsgStatusType.cancelling) {
					sendProgressAnalytics(_WAMConstants.wamMsgStatusType.cancelling.toLowerCase());
				}
			}
		}

		/* Get App from Apps list sent by Thor. Currenlty CCHome doesn't support previous versions of app Hence below method search an app only in latest version
   *  To support previous versions this method should support searching of app in previous versions also.
   * */

	}, {
		key: 'getProduct',
		value: function getProduct(prdouctListFromThor, sapCode, version, confirmationId) {
			if (!prdouctListFromThor || Object.keys(prdouctListFromThor).length === 0) {
				return null;
			}
			if (sapCode && version) {
				var products = prdouctListFromThor[_WAMConstants.thorAppsStatesCategory.activeSessions].filter(function (ele) {
					return ele.sapcode === sapCode && ele.version === version;
				});
				if (products.length > 0) {
					products[0].stateCategory = _WAMConstants.thorAppsStatesCategory.activeSessions;
					return products[0];
				}
				products = prdouctListFromThor[_WAMConstants.thorAppsStatesCategory.availableToInstall].filter(function (ele) {
					return ele.sapcode === sapCode && ele.version === version;
				});
				if (products.length > 0) {
					products[0].stateCategory = _WAMConstants.thorAppsStatesCategory.availableToInstall;
					return products[0];
				}
				products = prdouctListFromThor[_WAMConstants.thorAppsStatesCategory.availableToUpdate].filter(function (ele) {
					return ele.sapcode === sapCode && ele.version === version;
				});
				if (products.length > 0) {
					products[0].stateCategory = _WAMConstants.thorAppsStatesCategory.availableToUpdate;
					return products[0];
				}
				products = prdouctListFromThor[_WAMConstants.thorAppsStatesCategory.incompatible].filter(function (ele) {
					return ele.sapcode === sapCode && ele.version === version;
				});
				if (products.length > 0) {
					products[0].stateCategory = _WAMConstants.thorAppsStatesCategory.incompatible;
					return products[0];
				}
				products = prdouctListFromThor[_WAMConstants.thorAppsStatesCategory.incompatibleWithCheckprevious].filter(function (ele) {
					return ele.sapcode === sapCode && ele.version === version;
				});
				if (products.length > 0) {
					products[0].stateCategory = _WAMConstants.thorAppsStatesCategory.incompatibleWithCheckprevious;
					return products[0];
				}
				products = prdouctListFromThor[_WAMConstants.thorAppsStatesCategory.installed].filter(function (ele) {
					return ele.sapcode === sapCode && ele.version === version;
				});
				if (products.length > 0) {
					products[0].stateCategory = _WAMConstants.thorAppsStatesCategory.installed;
					return products[0];
				}
				if (!this.appUnkown) {
					return null;
				}
				products = this.appUnkown.filter(function (ele) {
					return ele.sapcode === sapCode && ele.version === version;
				});
				if (products.length > 0) {
					return {
						sapcode: products[0].sapcode,
						version: products[0].version,
						status: products[0].status,
						id: _uuid2.default.v4()
					};
				}
			} else if (confirmationId) {
				var filterOnConfirmationId = function filterOnConfirmationId(ele) {
					return ele && ele.status === _WAMConstants.wamMsgStatusType.needConfirmation && ele.confirmationDetails && ele.confirmationDetails.confirmationID === confirmationId;
				};
				var _products = prdouctListFromThor[_WAMConstants.thorAppsStatesCategory.installed].filter(function (ele) {
					return filterOnConfirmationId(ele);
				});
				if (_products.length > 0) {
					return _products[0];
				}
				_products = prdouctListFromThor[_WAMConstants.thorAppsStatesCategory.availableToInstall].filter(function (ele) {
					return filterOnConfirmationId(ele);
				});
				if (_products.length > 0) {
					return _products[0];
				}
				_products = prdouctListFromThor[_WAMConstants.thorAppsStatesCategory.availableToUpdate].filter(function (ele) {
					return filterOnConfirmationId(ele);
				});
				if (_products.length > 0) {
					return _products[0];
				}
				_products = prdouctListFromThor[_WAMConstants.thorAppsStatesCategory.incompatibleWithCheckprevious].filter(function (ele) {
					return filterOnConfirmationId(ele);
				});
				if (_products.length > 0) {
					_products[0].stateCategory = _WAMConstants.thorAppsStatesCategory.incompatibleWithCheckprevious;
					return _products[0];
				}
				_products = prdouctListFromThor[_WAMConstants.thorAppsStatesCategory.incompatible].filter(function (ele) {
					return filterOnConfirmationId(ele);
				});
				if (_products.length > 0) {
					return _products[0];
				}
				_products = prdouctListFromThor[_WAMConstants.thorAppsStatesCategory.activeSessions].filter(function (ele) {
					return filterOnConfirmationId(ele);
				});
				if (_products.length > 0) {
					return _products[0];
				}
			}
			return null;
		}

		/**
   * Parse the JSON and extract apps from it also extracts Thor app panel status.
   * @param statusData
   */

	}, {
		key: 'getAppsFromThor',
		value: function getAppsFromThor(statusData) {
			if (statusData && statusData.command === _WAMConstants.ccHomeCommands.ccHomeToThorCommands.fetchAppsListFromThor && statusData.status === _WAMConstants.wamMsgStatusType.thorAppsState.loaded) {
				var thorProductsList = JSON.parse(statusData.listingDetails);
				if (thorProductsList) {
					this.products = thorProductsList;
					if (statusData.confirmationDetails && statusData.confirmationDetails.confirmationSAPCode && statusData.confirmationDetails.confirmationVersion) {
						var product = this.getProduct(this.products, statusData.confirmationDetails.confirmationSAPCode, statusData.confirmationDetails.confirmationVersion);
						product.confirmationDetails = statusData.confirmationDetails;
						product.status = _WAMConstants.wamMsgStatusType.needConfirmation;
					}
				}
			} else if (statusData && statusData.status === _WAMConstants.wamMsgStatusType.thorAppsState.loadingFailed) {
				this.products = null;
				var errorDesc = _WAMUtil2.default.appendSourceInDesc('CreativeCloudDesktop failed to respond loaded status. Apps state:' + _WAMConstants.wamMsgStatusType.thorAppsState.loadingFailed);
				_AnalyticsUtil2.default.sendAnalytics({
					status: false,
					error: errorDesc
				});
				_AnalyticsUtil2.default.sendAnalytics({
					eventName: _WAMConstants.analyticsEvents.onClientRecvThorAppsState,
					status: false,
					errorType: 'error',
					errorDesc: errorDesc
				});
				_WAMUtil2.default.printLog(errorDesc);
			}
			this.thorAppsPanelStatus = statusData.status;
		}
	}, {
		key: 'addToAppUnkown',


		/**
   * Add the app to unknown category, Max release case
   * @param sapcode
   * @param version
   * @param status
   */
		value: function addToAppUnkown(sapcode, version, status) {
			this.appUnkown = this.appUnkown || [];
			this.appUnkown.push({ sapcode: sapcode, version: version, status: status });
		}
	}]);

	return WAMMessageManager;
}();

exports.default = new WAMMessageManager();